import React, {useState, useCallback} from 'react';
import {BrowserRouter as Router, Route, Redirect, Switch} from 'react-router-dom';

import './App.css';

import HomePage from './pages/homepage/homepage.component'; 
import Izvestaji from './pages/izvestaji/izvestaji.component';
import Izvestaj from './pages/izvestaj/izvestaj.component';
import StareNajave from './pages/starenajave/starenajave';
import Najave from './pages/najave/najave.components';
import KreirajIzvestaj from './pages/kreirajizvestaj/kreirajizvestaj.component';
import UpdateIzvestaj from './pages/updateIzvestaj/updateizvestaj';
import Navigation from './components/menu/navigation.components'; 
import Login from './pages/login/login';
import AboutUs from './pages/aboutUs/aboutus';
import GodisnjiPlan from './pages/godisnjiplan/godisnjiplan';
import ViaFerrata from './pages/viaferata/viaferata';
import OurTeam from './pages/ourteam/ourteam';
import KreirajNajavu from './pages/kreirajnajavu/kreirajnajavu';
import UpdateNajavu from './pages/updatenajavu/updatenajavu';
import {useAuth} from './utils/input/auth-hook';
import {AuthContext} from './utils/context/auth-context';

function App() {
  const { token, login, logout, userId } = useAuth();

let routes;

if(token){
  
  routes=(
    <Switch>
        <Route  exact path="/"> <HomePage/> </Route>
        <Route  exact path="/izvestaji"> <Izvestaji /> </Route>
        <Route  exact path="/najave"> <StareNajave /> </Route>
        <Route  exact path="/aboutus"> <AboutUs /> </Route>
        <Route  exact path="/godisnjiplan"> <GodisnjiPlan /> </Route>
        <Route  exact path="/viaferrata"> <ViaFerrata /> </Route>
        <Route  exact path="/nastim"> <OurTeam /> </Route>
        <Route  exact path="/izvestaji/:izvestajId"> <Izvestaj /> </Route>
        <Route  exact path="/izvestaj/new"> <KreirajIzvestaj /> </Route>
        <Route  exact path="/izvestaj/:id"> <UpdateIzvestaj /> </Route>
        <Route  exact path="/najave/:najavaId"> <Najave /> </Route>
        <Route  exact path="/najava/new"> <KreirajNajavu /> </Route>
        <Route  exact path="/najava/:id"> <UpdateNajavu /> </Route>        
       <Redirect to="/" />
  </Switch>
  );
} else {
  routes= (
    <Switch>
        <Route  exact path="/"> <HomePage/> </Route>
        <Route  exact path="/izvestaji"> <Izvestaji /> </Route>
        <Route  exact path="/najave"> <StareNajave /> </Route>
        <Route  exact path="/aboutus"> <AboutUs /> </Route>
        <Route  exact path="/godisnjiplan"> <GodisnjiPlan /> </Route>
        <Route  exact path="/viaferrata"> <ViaFerrata /> </Route>
        <Route  exact path="/nastim"> <OurTeam /> </Route>
        <Route  exact path="/izvestaji/:izvestajId"> <Izvestaj /> </Route>
        <Route  exact path="/najave/:najavaId"> <Najave /> </Route>
        <Route  exact path="/login"> <Login /> </Route>                    
        
        <Redirect to="/" />
    </Switch>
  );
}

  return (
    <AuthContext.Provider value={{ isLoggedIn: !!token, token: token, login: login, logout: logout }}>
    <Router> 
      <Navigation />
     {routes}
    </Router>
    </AuthContext.Provider>
  
  );
}

export default App;
